@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap");
@import url("https://api.fontshare.com/v2/css?f[]=switzer@400,500,600,700&display=swap");

@tailwind base;
@tailwind components;
@tailwind utilities;

:root {
  --bg-page: #f6f5f4;
  --bg-surface: #ffffff;
  --bg-soft: #f9fafb;
  --border-soft: #e5e7eb;
  --text-primary: #0e121b;
  --text-muted: #6d7a97;
}

.dark {
  --bg-page: #0b0e14;
  --bg-surface: #11151d;
  --bg-soft: #161b25;
  --border-soft: #232a37;
  --text-primary: #f1ebeb;
  --text-muted: #8a93a8;
}

html, body, #root { height: 100%; }

body {
  background: var(--bg-page);
  color: var(--text-primary);
  font-family: "Inter", system-ui, sans-serif;
  -webkit-font-smoothing: antialiased;
  margin: 0;
}

h1, h2, h3, h4 {
  font-family: "Switzer", "Inter", system-ui, sans-serif;
  letter-spacing: -0.01em;
}

input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0; }
input[type="number"] { -moz-appearance: textfield; }

.matrix-scroll::-webkit-scrollbar { height: 8px; }
.matrix-scroll::-webkit-scrollbar-track { background: transparent; }
.matrix-scroll::-webkit-scrollbar-thumb { background: #d1d5db; border-radius: 4px; }
.matrix-scroll::-webkit-scrollbar-thumb:hover { background: #9ca3af; }